import React, { useState } from "react";
import Input from "./Input";
import { useToasts } from "react-toast-notifications";
import Output from "./Output";
const Computing = (props) => {
  const { addToast } = useToasts();
  let details = {
    direction: 180,
    radius: 10,
    dmax: 30,
    dmin: 10,
    dis: 3,
    position:'pleft'
  };
  const [dimensions, setDimensions] = useState(details);
  const [isOutput, setIsOutput] = useState(false);
  const [isDebug, setDebug] = useState(false);
  const [isEditInput, setIsEditInput] = useState(false);
  const updateDimension = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    console.log(name, value);
    if (name === "direction" && (e.target.value < 0 || e.target.value > 359)) {
      addToast("Oops! Please choose the input value between 0 and 359", {
        appearance: "error",
      });

      return false;
    }
    let newdim = { ...dimensions };
    newdim[name] = value;
    setDimensions(newdim);
  };
  const showOutput = () => {
    setIsOutput(true);
    setDebug(false);
    setIsEditInput(false);
  };
  const showInput = () => {
    setIsOutput(false);
    setDebug(false);
    setIsEditInput(true);
  };
  // Reset Values button: zero every field shown on the input form
  const resetValues = () => {
    setDimensions({
      ...details,
      direction: 0,
      radius: 0,
      dmax: 0,
      dmin: 0,
      dis: 0,
    });
  };
  return !isOutput ? (
    <Input
      label="Proceed"
      isEditInput={isEditInput}
      dimensions={dimensions}
      updatedimension={updateDimension}
      showoutput={showOutput}
      resetvalues={resetValues}
      showobjective={() => props.setstep("objective")}
    />
  ) : (
    <Output
      showinput={showInput}
      showdebug={isDebug}
      setshowdebug={setDebug}
      dimensions={dimensions}
    />
  );
};

export default Computing;
